class GallerySlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const container = this.querySelector('[data-gallery-slider]');
    if (!container) return;

    const hasPagination = container.querySelector('.swiper-pagination');

    this.swiper = new Swiper(container, {
      loop: true,
      speed: 600,
      grabCursor: true,
      pagination: hasPagination
        ? {
            el: container.querySelector('.swiper-pagination'),
            clickable: true,
          }
        : false,
      navigation: {
        prevEl: container.querySelector('.swiper-button-prev'),
        nextEl: container.querySelector('.swiper-button-next'),
      },
      on: {
        slideChangeTransitionStart: () => {
          container.querySelectorAll('.gallery-slider__image-img').forEach((img) => {
            img.style.transition = 'opacity 0.4s ease';
          });
        },
      },
    });
  }
}

customElements.define('gallery-slider', GallerySlider);